/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Bench_Sidebar_Note_1Inputs */

const en_home_bench_sidebar_note_1 = /** @type {(inputs: Home_Bench_Sidebar_Note_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Built around your process.`)
};

const lv_home_bench_sidebar_note_1 = /** @type {(inputs: Home_Bench_Sidebar_Note_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veidots ap Jūsu procesu.`)
};

/**
* | output |
* | --- |
* | "Built around your process." |
*
* @param {Home_Bench_Sidebar_Note_1Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const home_bench_sidebar_note_1 = /** @type {((inputs?: Home_Bench_Sidebar_Note_1Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Bench_Sidebar_Note_1Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_home_bench_sidebar_note_1(inputs)
	return en_home_bench_sidebar_note_1(inputs)
});